module.exports = require("./../../_gen/starling/display/Mesh");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Mesh.js
// module id = 168
// module chunks = 0